import { useMemo } from "react";
import type { ReactNode } from "react";
import axios from "axios";
import type { AxiosInstance } from "axios";
import { ApiContext } from "./api-context.js";

interface ApiProviderProps {
  /** 自定义 axios 实例，不传则使用默认实例 */
  axiosInstance?: AxiosInstance;
  children: ReactNode;
}

export function ApiProvider({ axiosInstance, children }: ApiProviderProps) {
  const instance = useMemo(
    () =>
      axiosInstance ??
      axios.create({
        headers: { "Content-Type": "application/json" },
      }),
    [axiosInstance],
  );

  return <ApiContext.Provider value={instance}>{children}</ApiContext.Provider>;
}
